import { MeilisearchAttribute } from '../@api/Meilisearch';

enum CategoryWithCustomFilterOrder {
    diningTables = 'eettafels',
    diningRoomChairs = 'eetkamerstoelen',
    rugs = 'vloerkleden',
    cabinets = 'kasten',
    couches = 'banken',
    coffeeTables = 'salontafels',
    armchairs = 'fauteuils',
    hangingLamps = 'hanglampen',
    decorativePillows = 'sierkussens',
    chairs = 'stoelen',
    tables = 'tafels',
    sideTables = 'bijzettafels',
    wallDecoration = 'wanddecoratie',
    cornerCouches = 'hoekbanken',
    tvFurniture = 'tv-meubels',
    lighting = 'verlichting',
    crockery = 'servies',
}

const defaultFilterPriority = [
    MeilisearchAttribute.categories,
    MeilisearchAttribute.color,
    MeilisearchAttribute.material,
    MeilisearchAttribute.price,
];

const categoryFilterPriorities: Record<CategoryWithCustomFilterOrder, MeilisearchAttribute[]> = {
    [CategoryWithCustomFilterOrder.diningTables]: [
        MeilisearchAttribute.shapeOfTabletop,
        MeilisearchAttribute.materialOfTabletop,
        MeilisearchAttribute.width,
        MeilisearchAttribute.depth,
        MeilisearchAttribute.color,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.diningRoomChairs]: [
        MeilisearchAttribute.materialOfSeat,
        MeilisearchAttribute.color,
        MeilisearchAttribute.materialOfUnderside,
        MeilisearchAttribute.hasArmrests,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.rugs]: [
        MeilisearchAttribute.shapeOfRug,
        MeilisearchAttribute.typeOfRug,
        MeilisearchAttribute.width,
        MeilisearchAttribute.depth,
        MeilisearchAttribute.color,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.cabinets]: [
        MeilisearchAttribute.categories,
        MeilisearchAttribute.material,
        MeilisearchAttribute.width,
        MeilisearchAttribute.height,
        MeilisearchAttribute.color,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.couches]: [
        MeilisearchAttribute.numberOfSeats,
        MeilisearchAttribute.typeOfCouch,
        MeilisearchAttribute.material,
        MeilisearchAttribute.color,
        MeilisearchAttribute.width,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.coffeeTables]: [
        MeilisearchAttribute.shapeOfTabletop,
        MeilisearchAttribute.materialOfTabletop,
        MeilisearchAttribute.height,
        MeilisearchAttribute.color,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.armchairs]: [
        MeilisearchAttribute.color,
        MeilisearchAttribute.materialOfSeat,
        MeilisearchAttribute.width,
        MeilisearchAttribute.depth,
        MeilisearchAttribute.material,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.hangingLamps]: [
        MeilisearchAttribute.material,
        MeilisearchAttribute.color,
        MeilisearchAttribute.lightDirection,
        MeilisearchAttribute.isDimmable,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.decorativePillows]: [
        MeilisearchAttribute.material,
        MeilisearchAttribute.color,
        MeilisearchAttribute.print,
        MeilisearchAttribute.width,
        MeilisearchAttribute.depth,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.chairs]: [
        MeilisearchAttribute.categories,
        MeilisearchAttribute.materialOfSeat,
        MeilisearchAttribute.color,
        MeilisearchAttribute.materialOfUnderside,
        MeilisearchAttribute.hasArmrests,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.tables]: [
        MeilisearchAttribute.categories,
        MeilisearchAttribute.shapeOfTabletop,
        MeilisearchAttribute.materialOfTabletop,
        MeilisearchAttribute.color,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.sideTables]: [
        MeilisearchAttribute.shapeOfTabletop,
        MeilisearchAttribute.materialOfTabletop,
        MeilisearchAttribute.height,
        MeilisearchAttribute.color,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.wallDecoration]: [
        MeilisearchAttribute.categories,
        MeilisearchAttribute.width,
        MeilisearchAttribute.height,
        MeilisearchAttribute.color,
        MeilisearchAttribute.material,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.cornerCouches]: [
        MeilisearchAttribute.typeOfCouch,
        MeilisearchAttribute.width,
        MeilisearchAttribute.depth,
        MeilisearchAttribute.material,
        MeilisearchAttribute.color,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.tvFurniture]: [
        MeilisearchAttribute.width,
        MeilisearchAttribute.depth,
        MeilisearchAttribute.height,
        MeilisearchAttribute.material,
        MeilisearchAttribute.color,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.lighting]: [
        MeilisearchAttribute.categories,
        MeilisearchAttribute.material,
        MeilisearchAttribute.color,
        MeilisearchAttribute.isDimmable,
        MeilisearchAttribute.price,
    ],
    [CategoryWithCustomFilterOrder.crockery]: [
        MeilisearchAttribute.material,
        MeilisearchAttribute.color,
        MeilisearchAttribute.price,
    ],
};

// This function defines the order of filters presented based on given (sub)category
export const getPriorityFiltersForCategory = (category = ''): MeilisearchAttribute[] => {
    const priorities = categoryFilterPriorities[category as CategoryWithCustomFilterOrder];

    return priorities || defaultFilterPriority;
};
